/**
 * Actions have a type that where the name will show up in logs.
 */
export enum LanguageActions {
  GetAvailableLanguages = 'language/get-available-languages',
  GetAvailableLanguagesResponse = 'language/get-available-languages/success',
  GetAvailableLanguagesFailed = 'language/get-available-languages/failed',

  GetRegionalAndLanguageSettings = 'language/get-regional-and-language-settings',
  GetAvailableLocales = 'language/get-supported-regions',

  GetDateTimeFormats = 'language/get-date-time-formats',
  GetDateTimeFormatsAndMerge = 'language/get-date-time-formats-and-merge',
  GetAvailableTimezones = 'language/get-available-timezones',

  GetLanguagePreference = 'language/get-language-preference',
  GetLanguagePreferenceResponse = 'language/get-language-preference/success',
  GetLanguagePreferenceFailed = 'language/get-language-preference/failed',

  SetDisplayLanguage = 'language/set-display-language',
  SetDisplayLanguageResponse = 'language/set-display-language/success',
  SetDisplayLanguageFailed = 'language/set-display-language/failed',
  SetDisplayLanguageSetting = 'language/set-display-language-setting',

  SetDisplayLanguageBatch = 'language/set-display-language-batch',

  GetTranslationLanguage = 'language/get-translation-language',
  GetTranslationLanguageResponse = 'language/get-translation-language/success',
  GetTranslationLanguageFailed = 'language/get-translation-language/failed',

  SetTranslationLanguage = 'language/set-translation-language',
  SetTranslationLanguageResponse = 'language/set-translation-language/success',
  SetTranslationLanguageFailed = 'language/set-translation-language/failed',

  GetSpeechLanguage = 'language/get-speech-language',
  GetSpeechLanguageResponse = 'language/get-speech-language/success',
  GetSpeechLanguageFailed = 'language/get-speech-language/failed',

  SetSpeechLanguage = 'language/set-speech-language',
  SetSpeechLanguageResponse = 'language/set-speech-language/success',
  SetSpeechLanguageFailed = 'language/set-speech-language/failed',

  GetAuthoringLanguages = 'language/get-authoring-languages',
  GetAuthoringLanguagesResponse = 'language/get-authoring-languages/success',
  GetAuthoringLanguagesFailed = 'language/get-authoring-languages/failed',

  SetAuthoringLanguages = 'language/set-authoring-languages',
  SetAuthoringLanguagesResponse = 'language/set-authoring-languages/success',
  SetAuthoringLanguagesFailed = 'language/set-authoring-languages/failed',

  AddLastAuthoringLanguage = 'language/add-last-authoring-language',
  AddLastAuthoringLanguageResponse = 'language/add-last-authoring-language/success',
  AddLastAuthoringLanguageFailed = 'language/add-last-authoring-language/failed',

  SetDefaultRegionalFormat = 'language/set-default-regional-format',
  SetRegionalFormatting = 'language/set-regional-date-time-format',
  SetDateFormatOverride = 'language/set-date-format-override',
  SetTimeFormatOverride = 'language/set-time-format-override',
  SetTimezone = 'language/set-timezone',
  ResetLanguageRequestState = 'language/reset-language-request-state',
  UpdateComponentLoaded = 'language/update-component-loaded-state',
}
